import React from 'react';

export default function ProductInformation() {
  return (
    <div className="container-fluid mt100 pb40 relative">
      <img
        className="logo-salud-filled"
        src="https://sfestaticos.blob.core.windows.net/guideline/categories/salud.svg"
        alt="Logo Salud Complementario"
        width="134"
      />
      <div className="container text-center">
        <div className="row">
          <div className="col-12 text-center mb50">
            <h2 className="px-24 semibold">
              ¿Qué es el Seguro de Accidentes Personales?
            </h2>
            <p className="px-16">
              El seguro de accidentes personales está diseñado para dar protección y respaldo económico en caso de una eventualidad a consecuencia de un accidente o enfermedad.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
